<template>
    <region-compare-dot-plot-container
        v-if="chartType === 'regionCompareDotPlot'"
        :model="model"
    />
    <no-data-container
        v-else-if="chartType === 'noData'"
        :model="model"
    />
    <ranked-bar-chart-container
        v-else-if="chartType === 'rankedBar'"
        :model="model"
    />
    <bullet-chart-container
        v-else-if="chartType === 'bulletChart'"
        :model="model"
    />
    <dot-plot-container
        v-else-if="chartType === 'dotPlot'"
        :model="model"
    />
    <waffle-chart-container
        v-else-if="chartType === 'waffle'"
        :model="model"
    />
    <deprivation-chart-container
        v-else-if="chartType === 'deprivation'"
        :model="model"
    />
    <deprivation-metric-chart-container
        v-else-if="chartType === 'deprivation_type'"
        :model="model"
    />
    <multi-bullet-chart-container
        v-else-if="chartType === 'multiBulletChart'"
        :model="model"
    />
    <multi-dot-plot-container
        v-else-if="chartType === 'multiDotPlot'"
        :model="model"
    />
    <population-chart-container
        v-else-if="chartType === 'populationPyramid'"
        :model="model"
    />
    <population-growth-container
        v-else-if="chartType === 'populationGrowth'"
        :model="model"
    />
</template>

<script>
import BaseChartModel from '@/model/BaseChartModel';

import RegionCompareDotPlotContainer from '@/views/containers/RegionCompareDotPlotContainer.vue';
import NoDataContainer from './NoDataContainer.vue';
import RankedBarChartContainer from './RankedBarChartContainer.vue';
import BulletChartContainer from './BulletChartContainer.vue';
import DotPlotContainer from './DotPlotContainer.vue';
import WaffleChartContainer from './WaffleChartContainer.vue';
import DeprivationChartContainer from './DeprivationChartContainer.vue';
import DeprivationMetricChartContainer from './DeprivationMetricChartContainer.vue';
import MultiBulletChartContainer from './MultiBulletChartContainer.vue';
import MultiDotPlotContainer from './MultiDotPlotContainer.vue';
import PopulationChartContainer from './PopulationChartContainer.vue';
import PopulationGrowthContainer from './PopulationGrowthContainer.vue';

export default {
    components: {
        NoDataContainer,
        RankedBarChartContainer,
        BulletChartContainer,
        DotPlotContainer,
        WaffleChartContainer,
        DeprivationChartContainer,
        DeprivationMetricChartContainer,
        MultiBulletChartContainer,
        MultiDotPlotContainer,
        RegionCompareDotPlotContainer,
        PopulationChartContainer,
        PopulationGrowthContainer
    },
    props: {
        model: {
            type: BaseChartModel,
            required: true
        }
    },
    computed: {
        chartType() {
            if (this.model === null) {
                return '';
            }
            if (this.model.isNull && this.model.chartType !== 'regionCompareDotPlot') {
                return 'noData';
            }
            return this.model.chartType;
        }
    }
};
</script>

<style lang="postcss" scoped>
.chart-container {
    @apply relative pr-10;
}
</style>
